import { IGetAllCriterioAvaliacaoFornecedorUseCase } from "../../../presentation/useCases/read/get_all_criterio_avaliacao_fornecedor_use_case";
import { CriterioAvaliacaoFornecedor } from "../../models/criterio_avaliacao_fornecedor";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllCriterioAvaliacaoFornecedorUseCase
 */

export class GetAllCriterioAvaliacaoFornecedorUseCase implements IGetAllCriterioAvaliacaoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAllCriterioAvaliacaoFornecedor(): Promise<CriterioAvaliacaoFornecedor[]> {
    return await this.repository.getAllCriterioAvaliacaoFornecedor();
  }
}
